import React from 'react';
import { IconsPropsType } from './icons.config.type';

const LineOfEffortIcon: React.FC<IconsPropsType> = ({ style, color, onClick, className }) => {
  return (
    <svg
      style={{ ...style }}
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="15" cy="15" r="14.5" stroke="black" />
      <path
        d="M20.6516 18.4163L21.5199 13.4857L17.2528 15.7042L15.3462 11.8408L13.4435 15.6955L9.17639 13.4287L10.0089 18.4202L5.35938 19.0962L7.85801 21.5331H8.81903L6.80041 19.5647L10.7826 18.9842L10.0621 14.6582L13.7381 16.6131L15.3462 13.3553L16.9543 16.615L20.6245 14.7074L19.8702 18.9803L23.891 19.5647L21.8734 21.5331H22.8334L25.333 19.0962L20.6516 18.4163Z"
        fill="white"
      />
      <path
        d="M18.5296 19.705L19.0451 16.9583L16.4921 18.2031L15.3322 15.9999L14.1772 18.1946L11.6299 16.926L12.1233 19.7073L9.33301 20.0876L10.6941 21.3332H15.3322H19.9695L21.333 20.0876L18.5296 19.705Z"
        fill="white"
      />
      <path d="M20.636 7.33325L17.7124 13.6663L18.1895 13.8643L20.636 7.33325Z" fill="white" />
      <path d="M8.83252 17.4176L3.33301 13.1283L8.49834 17.8136L8.83252 17.4176Z" fill="white" />
      <path d="M24.2269 14.9711L21.7534 17.1123L22.1214 17.4745L24.2269 14.9711Z" fill="white" />
      <path d="M13.2839 13.6518L11.896 10.6866L12.7991 13.8334L13.2839 13.6518Z" fill="white" />
    </svg>

    // </div>
  );
};

LineOfEffortIcon.defaultProps = {
  style: { width: '30px', height: '30px' },
  color: '#fff',
  onClick: undefined,
  className: undefined,
};

export default LineOfEffortIcon;
